(function () {
    'use strict';

    angular
        .module('app.campaign')
        .controller('CustomSegmentDeleteModalController', CustomSegmentDeleteModal);

    CustomSegmentDeleteModal.$inject = ['customSegmentCount', 'close'];

    function CustomSegmentDeleteModal(customSegmentCount, close) {
        var vm = this;
        vm.customSegmentCount  = customSegmentCount;
        vm.confirmDelete = function(){
            close(true,500);
        }
    }
})();